import React, { useState, useContext, useEffect } from "react";

import Modal from "react-bootstrap/Modal";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import { Link } from "react-router";
import { useHistory } from "react-router-dom";
import { browserHistory } from "react-router";
import useApi from "../../../../hooks/useApi";
import externalApiService from "../../../../services/externalApiService";
import accountServices from "../../../../components/supply-chain/services/commonService";
import transactionService from "../../../../components/supply-chain/services/transaction_service";
import authService from "../../../../services/authService";
import coreService from "../../../../services/coreService";
import entityContext from "../../../../context/entityContext";
import LoadingSpinner from '../../../common/loaders/loadingSpinner';
import xero from "../../../../img/icons/xero_logo.png";
import myob from "../../../../img/icons/myob_logo.png";
import quickbook from "../../../../img/icons/quickbooks_logo.png";
import {
  getMappedSupplierList,    
} from "../../../supply-chain/services/userType";
import Utility from "../../../supply-chain/utils/DateParser";
import entityService from "../../../../services/entityService";
import { Picker } from "../../../common/inputs";
import Select from "react-select";


import NotConnectedCard from "./widgets/NotConnectedCard";
import RequestedCard from "./widgets/RequestedCard";
import PendingCard from "./widgets/PendingCard";
import InvoicesTable from "./widgets/InvoicesTable";
import ConnectModal from "./widgets/ConnectModal";
import AttachModal from "./widgets/AttachModal";
import AssignModal from "./widgets/AssignModal";
import CardSkelton from "../cards/_cardSkeltonTypeOne";
import InvoicesHistoryTable from "./widgets/InvoicesHistoryTable";

export default function AccountingSoftware({entityGuid, product, loading, onWidgetReload}) {

    const history = useHistory();

    const { ParseDate } = Utility();

    const accountingSoftwares = [
        {
            value: "Xero",
            label: "Xero",
            img_link: xero,
        },
        {
            value: "Myob",
            label: "Myob",
            img_link: myob,
        },
        {
            value: "Quickbook",
            label: "Quickbook",
            img_link: quickbook,
        }
    ];

    const statusConstants = {
        PENDING: "Pending",
        CONNECTED: "Connected",
        NOT_CONNECTED: "Not Connected",
        REQUESTED: "Requested",
        RECONNECT: "Reconnect",
    };

    const { 
        reloadAcAwaitingPayment, 
        setReloadAcAwaitingPayment,
        facilityStatus 
    } = useContext(entityContext);
    
    const { category, constants, country_id } = authService.getCurrentUser();
    
    const [isLoading, setIsLoading] = useState(false);
    const [accSwListModal, setAccSwListModal] = useState(false);
    const [selectedAccSw, setSelectedAccSw] = useState("");
    const [connectionStatus, setConnectionStatus] = useState(false);
    const [connectedAccSw, setConnectedAccSw] = useState("");
    const [invoices, setInvoices] = useState([]);
    const [invoicesList, setInvoicesList] = useState([]);
    const [userType, setUserType] = useState("account");
    const [attachModalOpen, setAttachModalOpen] = useState(false);
    const [attachItems, setAttachItems] = useState("");
    const [activeInvoiceId, setActiveInvoiceId] = useState(null);
    const [selectedTransactions, setSelectedTransactions] = useState([]);
    const [assignModalOpen, setAssignModalOpen] = useState(false);
    const [clientDebtorList, setClientDebtorList] = useState("");
    const [selectedClientDebtors, setSelectedClientDebtors] = useState({});
    const [syncSubmitting, setSyncSubmitting] = useState(false);
    const [revisedDueDate, setRevisedDueDate] = useState({});
    const [invNum, setInvNum] = useState(null);

    const [assignResult, setAssignResult] = useState(null); 
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [syncResult, setSyncResult] = useState(null); 
    const [syncResultModalOpen, setSyncResultModalOpen] = useState(false); 
    const [lastSynced, setLastSynced] = useState('N/A'); 
    const [autoSync, setAutoSync] = useState('no'); 
    const [revisedDueDateConstraints, setRevisedDueDateConstraints] = useState({});
    const [successModalOpen, setSuccessModalOpen] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [clientDebtorLoading, setClientDebtorLoading] = useState({});
    const [attachName, setAttachName] = useState("");

    const MAX_SELECTABLE = 10;

    const xeroReconnectApi = useApi(externalApiService.XeroReconnect);
    const statusApi = useApi(externalApiService.FetchConnectionAccSwStatus);
    const cancellationApi = useApi(accountServices.CancelConnectionRequest);
    const autoSyncApi = useApi(accountServices.AutoSyncAccounts);
    const fetchBills = useApi(externalApiService.GetBill);
    const searchBills = useApi(externalApiService.SearchBill);
    const fetchInvoiceAttachments = useApi(externalApiService.GetInvoiceAttachments);
    const mappedUsersApi = useApi(coreService.GetClientMappedUsers);
    const assignInvoice = useApi(externalApiService.assignInvoice);
    const assignInvoiceFinance = useApi(externalApiService.assignInvoiceFinance);
    const syncInvoice = useApi(externalApiService.syncInvoice);
    const maxRevisedDateApi = useApi(transactionService.maxRevisedDate);
    const fieldsHistoryApi = useApi(coreService.getFieldsMappingHistory);
    const deleteBills = useApi(externalApiService.DeleteBills);
    const getEntityDebtorsListApi = useApi(entityService.getEntityDebtorsList);

    const [showFacilityWarning, setShowFacilityWarning] = useState(false);
    const [facilityWarningMessage, setFacilityWarningMessage] = useState("");
    const [syncStatus, setSyncStatus] = useState('pending');
    

    const confirmAccSw = () => {
        setSelectedAccSw("");
        setAccSwListModal(true);
    };

    const isFacilitySuspended = () => {
        if (product === constants.PRODUCTS.TRADEFINANCE) {
            return String(facilityStatus?.tf_facility_status || "").toLowerCase() === "suspended";
        }
        return String(facilityStatus?.scf_facility_status || "").toLowerCase() === "suspended";
    };

    const getFacilitySubStatus = () => {
    if (product === constants.PRODUCTS.TRADEFINANCE) {
        return facilityStatus?.tf_facility_sub_status;
    }
    return facilityStatus?.scf_facility_sub_status;
    };

    const isEarlyRisk = String(getFacilitySubStatus() || "").toLowerCase() === "early risk";


    const EarlyRiskAlert = () => (
    <div className="alert alert-danger text-center mt-3">
        <i className="fa fa-info-circle mr-2"></i>
        <div>
        Our records show that your account is overdue.
        <br />
        If this payment has already been settled, please forward the remittance advice to{" "}
        <a href="mailto:support@fifocapital.com.au">
            support@fifocapital.com.au
        </a>
        </div>
    </div>
    );

    const fetchConnectionStatus = async () => {
        setIsLoading(true);
        const response = await statusApi.request({
            entityId: entityGuid,
            product: product,
        });
         
        if (response.data.success === true) {
            let lastSyncedDate = product === constants.PRODUCTS.INVOICE ? response.data.result.invoice_last_synced_at : response.data.result.last_synced_at;
            setConnectionStatus(response.data.result.connection_status);
            setConnectedAccSw(response.data.result.api_type);
            setLastSynced(lastSyncedDate);
            setAutoSync(response.data.result.auto_sync);

        } else {
            setConnectionStatus(statusConstants.NOT_CONNECTED);
        }

        setIsLoading(false);
    };
    
    const handleDisconnection = async () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-delete-ui">
                        <h4>Disconnection Request</h4>
                        <p>Are You Sure You Wish To Disconnect?</p>
                        <button
                            className="btn btn-white"
                            onClick={() => { onClose(); }}
                        >
                            No
                        </button>
                        <button
                            className="btn btn-primary ml-2"
                            onClick={async () => {
                                const response = await cancellationApi.request({
                                entity_id: entityGuid,
                                });
                                if (response.data.success === true) {
                                    toast.success("You have been successfully disconnected.");
                                    fetchConnectionStatus();
                                } else toast.error(response.data.message);
                                    onClose();
                                }
                            }
                        >
                            Yes
                        </button>
                    </div>
                );
            },
            title: "",
            message: ``,
        });
    };

    const handleAutoSync = async () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-delete-ui">
                        <h4>{autoSync == 'yes' ? 'Disable' : 'Enable'} Auto Sync</h4>
                        <p>Are You Sure You Wish To {autoSync == 'yes' ? 'Disable' : 'Enable'} Auto Sync?</p>
                        <button
                            className="btn btn-white"
                            onClick={() => { onClose(); }}
                        >
                            No
                        </button>
                        <button
                            className="btn btn-primary ml-2"
                            onClick={async () => {
                                const response = await autoSyncApi.request({
                                    entity_id: entityGuid,
                                });
                                if (response.data.success === true) {
                                    toast.success(response.data.message);
                                    fetchConnectionStatus();
                                    onClose();
                                } else 
                                    toast.error(response.data.message);
                                    onClose();
                                }
                            }
                        >
                            Yes
                        </button>
                    </div>
                );
            },
            title: "",
            message: ``,
        });
    };

    const handleConfirmConnection = () => {
        confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className="custom-delete-ui">
                <h4>Connect to Xero</h4>
                <p>You are about to be redirected to Xero's website to authenticate your account.
                            After successful authentication, you’ll be redirected back automatically.
                            Would you like to proceed?</p>
                <button
                  className="btn btn-white"
                  onClick={() => {
                    onClose();
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary ml-2"
                  onClick={() => {
                    xeroReconnect();
                    onClose();
                  }}
                >
                  Proceed
                </button>
              </div>
            );
          },
          title: "Are you sure?",
          message: `Are you sure want to continue ...?`,
        });
    };

    const getReturnUrl = () => {
        const RETURN_URL_MAP = {
            [constants.PRODUCTS.SUPPLYCHAIN]: "/client/scf/dashboard",
            [constants.PRODUCTS.TRADEFINANCE]: "/client/tf/dashboard",
            [constants.PRODUCTS.INVOICE]: "/client/if/dashboard",
        };

        return RETURN_URL_MAP[product] || "/client/accounting-software";
    };

    const xeroReconnect = async () => {
        if (!connectedAccSw) {
            toast.error("No accounting software selected for reconnection.");
            return;
        }

        const response = await xeroReconnectApi.request({
            entityId: entityGuid,
            api_type: connectedAccSw,
            return_url: getReturnUrl(),
        });

        if (response) {
            if (response.data.success === true) {
                if (response.data.authUrl) {
                    window.location.href = response.data.authUrl;
                } else {
                    toast.success(response.data.message);
                    fetchConnectionStatus();
                }
            } else {
                toast.error(response.data.message || `Failed to reconnect with ${connectedAccSw}`);
            }
        }
    };

    const fetchAccSoftInvoices = async () => {
        setIsLoading(true)
        const response = await fetchBills.request({ 
            entityId: entityGuid, 
            productId: product,
            inv_number: invNum,
        })
        if (response.data.success === true) {
            setInvoices(response.data.data);
        } 

        setIsLoading(false);
    }

    const searchAccSoftInvoices = async () => {
        setIsLoading(true)
        const response = await searchBills.request({ 
            entityId: entityGuid, 
            productId: product,
        })
        if (response.data.success === true) {
            setInvoicesList(response.data.data);
        } 

        setIsLoading(false);
    }

    // const handleShowAttachments = async (ref_id) => {
    //     setIsLoading(true)
    //     setActiveInvoiceId(ref_id);
    //     const response = await fetchInvoiceAttachments.request({
    //         entityId: entityGuid, 
    //         invoiceId: ref_id,
    //     })
    //     if (response.status === 200 && response.data.success) {
    //         setAttachItems(response.data.payload.file);
    //         setAttachModalOpen(true);
    //     } 
    //     else{
    //         toast.error(response.data.message);
    //     }
    //     setIsLoading(false);
    // }


    const handleShowAttachments = async (ref_id) => {
        setIsLoading(true);
        setActiveInvoiceId(ref_id);

        try {
            const response = await fetchInvoiceAttachments.request({
                entityId: entityGuid,
                invoiceId: ref_id,
            });

            if (response?.data?.requires_reconnect) {
                toast.error(`Your ${connectedAccSw || 'accounting software'} connection has expired. Please reconnect your account.`);
                setAttachModalOpen(false);
                fetchConnectionStatus();
                return;
            }

            if (response?.status === 200 && response?.data?.success) {
                setAttachItems(response.data.payload.file);
                setAttachName(response.data.payload.name || 'attachment');
                setAttachModalOpen(true);
            } else {
                toast.error(response?.data?.message || 'Failed to fetch attachment');
            }
        } catch (error) {
            toast.error('Failed to fetch attachment');
        } finally {
            setIsLoading(false);
        }
    };

    const handleSelect = (checked, id) => {
        setSelectedTransactions((prev) => {
            if (checked) {
                if (prev.length >= MAX_SELECTABLE) {
                    toast.error(`You can select up to ${MAX_SELECTABLE} invoices only`);
                    return prev;
                }

                const selectedItem = (invoices || []).find((item) => item.ref_id === id);
                if (!selectedItem) return prev;
                return prev.some((item) => item.ref_id === id) ? prev : [...prev, selectedItem];
            } else {
                    return prev.filter((item) => item.ref_id !== id);
            }
        });
    };

    const handleSelectAll = (checked) => {
        if (!checked) {
            setSelectedTransactions([]);
            return;
        }

        // if already some selected, fill remaining up to max
        const alreadySelectedIds = new Set(selectedTransactions.map(s => s.ref_id));
        const space = MAX_SELECTABLE - selectedTransactions.length;
        if (space <= 0) {
            toast.error(`You can select up to ${MAX_SELECTABLE} invoices only`);
            return;
        }

        const availableToAdd = (invoices || []).filter(inv => !alreadySelectedIds.has(inv.ref_id)).slice(0, space);
        if (availableToAdd.length === 0) {
            toast.info('No more invoices available to select');
            return;
        }

        setSelectedTransactions((prev) => [...prev, ...availableToAdd]);
    };

    const changeClientDebtor = async (invoiceId, selectedOption) => {
        if (!selectedOption) return;
        
        const invoice = invoices.find((t) => t.ref_id === invoiceId) || {};
        setSelectedClientDebtors((prev) => ({
            ...prev,
            [invoiceId]: { label: selectedOption.label, value: selectedOption.value, column: invoice.supplier, },
        }));
        
       // handleMaxRevisedDate(invoiceId,selectedOption)
        if (product === constants.PRODUCTS.INVOICE) {

        }
        else{

            setClientDebtorLoading((m) => ({ ...m, [invoiceId]: true }));

            try {
                await handleMaxRevisedDate(invoiceId, selectedOption);
            } catch (err) {
                toast.error('Failed to update supplier mapping');
            } finally {
                // clear loading for the row
                setClientDebtorLoading((m) => {
                    const copy = { ...m };
                    delete copy[invoiceId];
                    return copy;
                });
            }
        }
    };

    const handleMaxRevisedDate = async (invoiceId, selectedOption) => {
        setRevisedDueDateConstraints((prev) => ({ ...prev, [invoiceId]: undefined }));

        // find the invoice for extra params
        const invoice = invoices.find((t) => t.ref_id === invoiceId) || {};
        // prepare payload 
        const payload = {
            customer: entityGuid ?? null,
            supplier: selectedOption.value,
            trans_date: invoice.date ?? null,
            inv_due_date: invoice.dueDate ?? null,
            invoiceId: invoiceId,
        };

        try {
            
            const resp = await maxRevisedDateApi.request(payload);
            if (resp && resp.success) {
                const { extension_field, maxRevisedDate } = resp;        
                const minDate = (extension_field == 'invoice_date') ? invoice.date : invoice.dueDate;
                setRevisedDueDateConstraints((prev) => ({
                    ...prev,
                    [invoiceId]: {
                        minDate: minDate || null,
                        maxDate: maxRevisedDate || null,    
                    },
                }));
                const inv_rev_due = maxRevisedDate ? new Date(maxRevisedDate) : null;
                setRevisedDueDate((prev) => ({ ...prev, [invoiceId]: inv_rev_due}));
            } else {
                toast.error(resp?.data?.message || 'Failed to fetch revised due date limits');
            }
        } catch (err) {
            //console.error('Error fetching revised date limit', err);
            toast.error('Unable to fetch revised date limits');
        }
    }

    const handleSyncSubmit = async () => {
        const missing = selectedTransactions.filter(
            (trans) => !selectedClientDebtors[trans.ref_id]?.value
        );
        if (missing.length > 0) {
            toast.error('Please map a Supplier for all selected invoices.');
            return;
        }

        if(category === constants.CATEGORY.TRADERS){
            setReloadAcAwaitingPayment(false);
        }

        const ASSIGN_INVOICE_MAP = {
            [constants.PRODUCTS.INVOICE]: assignInvoiceFinance,  
            default: assignInvoice,                              
        };

        const service = ASSIGN_INVOICE_MAP[product] || ASSIGN_INVOICE_MAP.default;
        
        const payload = selectedTransactions.map((trans) => ({
            ...trans,
            supplier: selectedClientDebtors[trans.ref_id].value,
            inv_revised_due_date: revisedDueDate[trans.ref_id] ? ParseDate(revisedDueDate[trans.ref_id]) : null,
        }));
        setSyncSubmitting(true);

        try {
            
            const { data } = await service.request({
                invoices: payload,
                entity_id: entityGuid,
                product: product, 
                selectedSupplier: selectedClientDebtors,
            });

            // Check if there were any errors reported by the API
            const hasErrors =
            !data.success ||
            (Array.isArray(data.errors) && data.errors.length > 0);

            if (!hasErrors) {
                setAssignModalOpen(false);
                setSelectedTransactions([]);
                setSelectedClientDebtors({});
                setRevisedDueDate({});
                fetchAccSoftInvoices();
                if(category === constants.CATEGORY.TRADERS){
                    setReloadAcAwaitingPayment(true);
                }
                
                setSuccessMessage(data.message || 'Uploaded successfully');
                setSuccessModalOpen(true);

            } else {
                // Errors present: store result and open the result modal
                setAssignResult(data);
                setResultModalOpen(true);
                // Hide the assign modal and clear selections
                setAssignModalOpen(false);
                setSelectedTransactions([]);
                setSelectedClientDebtors({});
                setRevisedDueDate({});
                if(category === constants.CATEGORY.TRADERS){
                    setReloadAcAwaitingPayment(!reloadAcAwaitingPayment);
                }
            }
        } catch (error) {
            setAssignResult({
                success: false,
                message: 'Error syncing invoices',
                errors: [{ invoice_no: '', error: error.message }],
            });
            setResultModalOpen(true);
            setAssignModalOpen(false);
        } finally {
            setSyncSubmitting(false);
        }
    };

    const handleAssignOpen = () => {
        // disable sync if facility is suspended
        if (isFacilitySuspended()) {
            setFacilityWarningMessage(
            <>
                Our records show that your facility has been in arrears for more than 10 days.
                <br />
                Please make payment immediately.
                <br /><br />
                If this payment has already been settled, please forward the remittance advice to{" "}
                <a href="mailto:support@fifocapital.com.au">
                support@fifocapital.com.au
                </a>
            </>
            );
            setShowFacilityWarning(true);
            return;
        }

        if (selectedTransactions.length === 0) {
            toast.info("Select at least one invoice to sync.");
            return;
        }
        setAssignModalOpen(true);
    };

    const handleDelete = async () => {
        if (selectedTransactions.length === 0) {
            toast.info("Select at least one invoice to delete.");
            return;
        }

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-delete-ui">
                        <h4>Delete Confirmation</h4>
                        <p>
                            Are you sure you want to delete{" "}
                            <strong>{selectedTransactions.length}</strong>{" "}
                            selected invoice{selectedTransactions.length > 1 ? "s" : ""}?
                        </p>
                        <div className="d-flex justify-content-center mt-3">
                            <button
                                className="btn btn-white"
                                onClick={onClose}
                            >
                                No
                            </button>
                            <button
                                className="btn btn-primary ml-2"
                                onClick={async () => {
                                    try {
                                        setIsLoading(true);
                                        const transGuids = selectedTransactions.map(
                                            item => item.trans_guid
                                        );
                                        const response = await deleteBills.request(transGuids);

                                        if (response.data.success === true) {
                                            toast.success(response.data.message);
                                        } else {
                                            toast.error(response.data.message);
                                        }

                                        setSelectedTransactions([]);
                                        setSelectedClientDebtors({});
                                        setRevisedDueDate({});
                                        fetchAccSoftInvoices();
                                    } catch (error) {
                                        toast.error("Something went wrong. Please try again.");
                                    } finally {
                                        setIsLoading(false);
                                        onClose();
                                    }
                                }}
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                );
            },
            title: "",
            message: "",
        });
    };

    // const fetchMappedUser = async () => {
    //     const items = null;
    //     if(selProduct == constants.PRODUCTS.INVOICE){
    //         items  = await getEntityDebtorsListApi.request({
    //             entity_id,
    //             product : selProduct,
    //         });
    //     }
    //     else{
    //         items = await getMappedSupplierList(
    //             country_id,
    //             "Supplier",
    //             entity_id,
    //             selProduct,
    //         );
    //     }
        
    //     if (!items) {
    //         toast.error('Failed to load customer/debtor');
    //     } else {
    //         setClientDebtorList(items);
    //     }
    // }

    const fetchMappedUser = async () => {
        try {
            let items = null;

            if (product === constants.PRODUCTS.INVOICE) {
            // For INVOICE fetch debtor list
                const resp = await getEntityDebtorsListApi.request(
                    entityGuid,
                    product,
                );
                items = resp.data
            } else {
            // For other products fetch mapped suppliers
                items = await getMappedSupplierList(
                    country_id,
                    "Supplier",
                    entityGuid,
                    product
                );
            }

            if (!items) {
            toast.error("Failed to load customer/debtor");
            return;
            }

            setClientDebtorList(items);

        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        }
    };


    const handleSync = async () => {
        setIsLoading(true);

        try {
            const {data} = await syncInvoice.request({ entity_id: entityGuid, product : product}); 

            // Check if there were any errors reported by the API
            const hasErrors =
            !data.success ||
            (Array.isArray(data.errors) && data.errors.length > 0);
            if (data?.requires_reconnect) {
                confirmAlert({
                    customUI: ({ onClose }) => {
                        return (
                            <div className="custom-delete-ui">
                                <h4>Reconnect Required</h4>
                                <p>
                                    Your {connectedAccSw || "accounting software"} connection has expired.
                                    Please reconnect to continue.
                                </p>
                                <button
                                    className="btn btn-primary ml-2"
                                    onClick={() => {
                                        onClose();
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        );
                    },
                });
                return;
            }

            if (!hasErrors) {
                // No errors: show a toast message only
                toast.success(data.message || 'Synced successfully');
                // Reset UI and refresh list
                setSyncResultModalOpen(false);
                fetchAccSoftInvoices();
            } else {
                // Errors present: store result and open the result modal
                setSyncResult(data);
                setSyncResultModalOpen(true);
                fetchAccSoftInvoices();
            }
            
            
        } catch (error) {
            // Unexpected error: treat as failure and show in modal
            setSyncResult({
                success: false,
                message: 'Error syncing invoices',
                errors: [{ invoice_no: '', error: error.message }],
            });
            setSyncResultModalOpen(true);
        } finally {
            fetchConnectionStatus();
            setIsLoading(false);
        }
    }

    const Stat = ({ label, value }) => {
        return (
            <div className="p-2 px-3 rounded border mr-4">
          
            <h6 className="fs-5">{value}</h6>
              <div className="fw-semibold">{label}</div>
            </div>
        );
    }

    const handleCancellation = () => {
        confirmAlert({
          customUI: ({ onClose }) => {
            return (
            <div className="custom-delete-ui">
                <h4>Request Cancellation</h4>
                <p>Are You Sure You Wish To Cancel?</p>
                <button
                  className="btn btn-white"
                  onClick={() => {
                    onClose();
                  }}
                >
                  No
                </button>
                <button
                  className="btn btn-primary ml-2"
                  onClick={async () => {
                    const response = await cancellationApi.request({
                      entity_id: entityGuid,
                    });
                    if (response.data.success === true) {
                      toast.success(response.data.message);
                      fetchConnectionStatus();
                    } else toast.error(response.data.message);
                    onClose();
                  }}
                >
                  Yes
                </button>
              </div>
            );
          },
          title: "",
          message: ``,
        });
    };

    // const getSupplierMappingHistory = async () => {
    //     // only proceed if clientDebtorList and selectedTransactions are available and we don't already have mappings
    //     if (!Array.isArray(clientDebtorList) || clientDebtorList.length === 0) return;
    //     if (!Array.isArray(selectedTransactions) || selectedTransactions.length === 0) return;
    //     if (Object.keys(selectedClientDebtors).length > 0) return; 
         
    //     try {
    //         const resp = await fieldsHistoryApi.request({
    //             account: entityGuid,
    //             product : product,
    //             type: constants.FIELD_MAPPING.PAYABLE_INV_UPLOADER_MAP_SUPPLIER
    //         });

    //         const mappingHistory = resp?.data?.data ?? [];

    //         if (!Array.isArray(mappingHistory) || mappingHistory.length === 0) return;

    //         // Build a mapping object keyed by invoice ref_id
    //         const mappings = {};
    //         const promises = [];
           
    //         selectedTransactions.forEach((invoice) => {
    //             const res = mappingHistory.find(item => item.actual_field === invoice.supplier);
    //             if (res) {
    //                 const supplierInfo = clientDebtorList.find(item => String(item.value) === String(res.mapped_field));

    //                 if (!supplierInfo) return;

    //                 mappings[invoice.ref_id] = {
    //                     label: supplierInfo.label,
    //                     value: supplierInfo.value,
    //                     column: invoice.supplier,
    //                 };

    //                 if (clientDebtorList.some(item => String(item.value) === String(supplierInfo.value))) {

    //                     setClientDebtorLoading(m => ({ ...m, [invoice.ref_id]: true }));

    //                     const p =  handleMaxRevisedDate(invoice.ref_id, {
    //                         label: supplierInfo.label,
    //                         value: supplierInfo.value,
    //                     })
    //                      .catch(err => {
    //                         console.error('handleMaxRevisedDate error for', invoice.ref_id, err);
    //                     })
    //                     .finally(() => {
    //                         // clear loading for this invoice
    //                         setClientDebtorLoading(m => {
    //                         const copy = { ...m };
    //                         delete copy[invoice.ref_id];
    //                         return copy;
    //                         });
    //                     });

    //                     promises.push(p);
    //                 }    

    //             }
    //         });

    //         // Merge with any existing mappings (if any) and set
    //         if (Object.keys(mappings).length > 0) {
    //             setSelectedClientDebtors((prev) => ({ ...mappings, ...prev }));
    //         }

    //         if (promises.length > 0) {
    //             await Promise.all(promises);
    //         }
    //     } catch (err) {
    //         console.error('Failed to fetch mapping history', err);
    //     }
    // }

    const getSupplierMappingHistory = async () => {
        if (!Array.isArray(clientDebtorList) || clientDebtorList.length === 0) return;
        if (!Array.isArray(selectedTransactions) || selectedTransactions.length === 0) return;

        try {
            const mappingType =
                product === constants.PRODUCTS.INVOICE
                    ? constants.FIELD_MAPPING.IF_INV_UPLOADER_MAP_SUPPLIER
                    : constants.FIELD_MAPPING.PAYABLE_INV_UPLOADER_MAP_SUPPLIER;

            const resp = await fieldsHistoryApi.request({
                account: entityGuid,
                product: product,
                type: mappingType,
            });

            const mappingHistory = resp?.data?.data ?? [];

            if (!Array.isArray(mappingHistory) || mappingHistory.length === 0) return;

            const mappings = {};
            const promises = [];

            selectedTransactions.forEach((invoice) => {
                const res = mappingHistory.find(
                    item => String(item.actual_field).trim() === String(invoice.supplier).trim()
                );

                if (!res) return;

                const debtorInfo = clientDebtorList.find(
                    item => String(item.value) === String(res.mapped_field)
                );

                if (!debtorInfo) return;

                mappings[invoice.ref_id] = {
                    label: debtorInfo.label,
                    value: debtorInfo.value,
                    column: invoice.supplier,
                };

                // Revised due date only needed for SCF/TF, not Invoice Finance
                if (product !== constants.PRODUCTS.INVOICE) {
                    setClientDebtorLoading(m => ({ ...m, [invoice.ref_id]: true }));

                    const p = handleMaxRevisedDate(invoice.ref_id, {
                        label: debtorInfo.label,
                        value: debtorInfo.value,
                    })
                        .catch(err => {
                            console.error("handleMaxRevisedDate error for", invoice.ref_id, err);
                        })
                        .finally(() => {
                            setClientDebtorLoading(m => {
                                const copy = { ...m };
                                delete copy[invoice.ref_id];
                                return copy;
                            });
                        });

                    promises.push(p);
                }
            });

            if (Object.keys(mappings).length > 0) {
                setSelectedClientDebtors(prev => ({ ...mappings, ...prev }));
            }

            if (promises.length > 0) {
                await Promise.all(promises);
            }
        } catch (err) {
            console.error("Failed to fetch mapping history", err);
        }
    };

    const closeSuccessModal = () => {
        setSuccessModalOpen(false);
        setAssignModalOpen(false);
        if (typeof onWidgetReload === "function") {
            onWidgetReload();
        }
    };

    useEffect(() => {
        fetchConnectionStatus();
        fetchAccSoftInvoices();
        searchAccSoftInvoices();
    }, []);

    useEffect(() => {
        if (autoSync === 'yes' && connectionStatus === statusConstants.CONNECTED) {
            handleSync();
        }
    }, [autoSync]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const authCode = urlParams.get("code");
        const stateParam = urlParams.get("state"); 

        let uid = null;
        let provider = null;
        let returnUrl = null;

        if (stateParam) {
            try {
                // Decode base64 and parse JSON
                const decoded = JSON.parse(atob(stateParam));
                uid = decoded.uid;
                provider = decoded.provider;
                returnUrl = decoded.returnUrl;
            } catch (err) {
                console.error("Failed to decode state param:", err);
            }
        }

        if (authCode) {
            const entityId = entityGuid;
            
            // Use query parameters for navigation
            const queryParams = new URLSearchParams();
            queryParams.set("authCode", authCode);
            queryParams.set("xeroState", uid); //xeroState
            queryParams.set("provider", provider);
            queryParams.set("entityId", entityId);
            queryParams.set("return_url", returnUrl);

            // Construct the new URL
            const newUrl = `/client/token-endpoint?${queryParams.toString()}`;
            // Use browserHistory.push for navigation
            browserHistory.push(newUrl);
        } else fetchConnectionStatus();
    }, [browserHistory, entityGuid]);

    useEffect(() => {
         getSupplierMappingHistory();
    }, [clientDebtorList, selectedTransactions, product])

    useEffect(() => {
        if (assignModalOpen) fetchMappedUser();
    }, [assignModalOpen]);

    useEffect(() => {
        fetchAccSoftInvoices();
    }, [invNum]);


    return (
        <>
            {loading ? (<CardSkelton col={12} type="normal" />) : (
                <>
                    {isLoading && (<LoadingSpinner />)}

                    {connectionStatus === statusConstants.NOT_CONNECTED && (
                        <NotConnectedCard 
                            onConnectClick={confirmAccSw}
                            title="Sync Your Accounting Software"
                            description="Say goodbye to manual data entry and bulk uploads. Connect your accounting software and watch your invoices flow seamlessly into your dashboard — automatically and effortlessly."
                        />
                    )}

                    {connectionStatus === statusConstants.RECONNECT && (
                        <NotConnectedCard 
                            onConnectClick={confirmAccSw} 
                            title="Reconnect Your Accounting Software"
                            description="Your connection has expired. Reconnect now to resume automatic syncing and keep your invoices up to date without any manual effort."
                        />
                    )}

                    {connectionStatus === statusConstants.REQUESTED && (
                        <RequestedCard
                            connectedAccSw={connectedAccSw}
                            onConfirm={handleConfirmConnection}
                            onCancel={handleCancellation}
                        />
                    )}

                    {connectionStatus === statusConstants.PENDING && (
                        <PendingCard
                            connectedAccSw={connectedAccSw}
                            onConfirm={handleConfirmConnection}
                            fetchConnectionStatus={fetchConnectionStatus}
                            entityGuid={entityGuid}
                            onCancel={handleCancellation}
                        />
                    )}

                    { connectionStatus === statusConstants.CONNECTED && (
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div id="acc-sw" className="col-8 col-lg-12 m-auto text-center ">
                                        <div className="d-flex align-items-center justify-content-between p-4     ">
                                            {/* Left section: Image + Text */}
                                            <div className="d-flex">
                                                {(() => {
                                                const filtered = accountingSoftwares.filter(
                                                    (itm) => itm.label === connectedAccSw
                                                );

                                                return filtered.map((itm, index) => (
                                                    <img
                                                    key={itm.value || index}
                                                    height="50px"
                                                    src={itm.img_link}
                                                    className="rounded-circle mr-3"
                                                    />
                                                ));
                                                })()}
                                                <div className="d-flex flex-column justify-content-center" >
                                                    <span className="font-weight-bold mb-0 text-left">
                                                        You are connected
                                                    </span>
                                                    <small className="text-muted mb-0 text-left">
                                                        Last Sync: {lastSynced}
                                                    </small>
                                                </div>
                                            </div>

                                            {/* Right section: Settings dropdown */}
                                            <div className="dropdown ml-auto">
                                                <button
                                                    className="btn btn-light btn-sm dropdown-toggle pr-4"
                                                    type="button"
                                                    id="settingsDropdown"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                >
                                                    Actions 
                                                </button>
                                                <div
                                                    className="dropdown-menu dropdown-menu-right"
                                                    aria-labelledby="settingsDropdown"
                                                >
                                                    {category === constants.CATEGORY.TRADERS && (
                                                        <button
                                                            type="button"
                                                            className="dropdown-item"
                                                            onClick={handleAutoSync}
                                                        >
                                                            {autoSync === 'yes' ? 'Disable' : 'Enable'} Auto Sync
                                                        </button>
                                                    )}
                                                    <button className="dropdown-item"  onClick={handleSync}>
                                                        Sync Now
                                                    </button>
                                                    <button className="dropdown-item"  onClick={() => { setSyncStatus('pending') }}>
                                                        Pending Invoices
                                                    </button>
                                                    <button className="dropdown-item"  onClick={() => { setSyncStatus('previous') }}>
                                                        Previous History
                                                    </button>
                                                    {category === constants.CATEGORY.TRADERS && (
                                                        <button
                                                        type="button"
                                                        className="dropdown-item text-danger"
                                                        onClick={handleDisconnection}
                                                        >
                                                        Disconnect
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        { syncStatus === 'previous' && (
                                       
                                                <h6 className="mb-0">Previous History</h6>
                                            
                                        )}
                                            
                                        {/*------------- accounting sw invoices / bills ------------------------*/}
                                        
                                        <div className="row">
                                            {
                                                selectedTransactions.length > 0 && (
                                                    <div className="col-md-12">
                                                        <div className="d-flex justify-content-end align-items-center">
                                                            <div>
                                                                <button className="btn btn-sm btn-outline-danger mr-2"
                                                                        onClick={handleDelete}
                                                                    >
                                                                Delete ({selectedTransactions.length})
                                                                </button>
                                                                <button className="btn btn-sm btn-primary"
                                                                        onClick={handleAssignOpen}
                                                                    >
                                                                Submit For Funding ({selectedTransactions.length})
                                                                </button>
                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            <div className="col-md-12">
                                                {
                                                    (syncInvoice.loading) ? (
                                                        <>
                                                            <div className="text-center">
                                                                <LoadingSpinner normal="true" />
                                                                <span className="text-primary">Connecting to accounting software ...</span>
                                                            </div>
                                                        </>
                                                    ) :
                                                    (   <>
                                                        <div className="col-md-4">
                                                            <Select
                                                            options={invoicesList}
                                                            placeholder="Search here"
                                                            isClearable
                                                            components={{ DropdownIndicator: () => null }}
                                                            value={invoicesList.find(item => item.value === invNum)}
                                                            theme={theme => ({
                                                                ...theme,
                                                                borderRadius: '.375rem',
                                                                border: "1px solid #b0b9c1",
                                                                colors: {
                                                                ...theme.colors,
                                                                text: "black",
                                                                primary25: "white",
                                                                primary: "#1ab394",
                                                                neutral0: "white"
                                                                }
                                                            })}
                                                            styles={{
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                menu: base => ({ ...base, zIndex: 9999 })
                                                            }}
                                                            onChange={(selectedOption) => {
                                                                if (!selectedOption) {
                                                                    setInvNum("");      
                                                                }
                                                                setInvNum(selectedOption ? selectedOption.value : null);
                                                            }}
                                                            />
                                                        </div>
                                                        <div className="mt-2">
                                                           {invoices.length > 0 ? (
                                                                syncStatus === 'pending' ? (
                                                                    <InvoicesTable
                                                                        invoices={invoices}
                                                                        selectedTransactions={selectedTransactions}
                                                                        onSelect={handleSelect}
                                                                        onShowAttachments={handleShowAttachments}
                                                                        handleSelectAll={handleSelectAll}
                                                                        MAX_SELECTABLE={MAX_SELECTABLE}
                                                                        selProduct={product}
                                                                    />
                                                                ) : (
                                                                    <InvoicesHistoryTable  
                                                                        entityGuid={entityGuid}
                                                                        selProduct={product}
                                                                        onShowAttachments={handleShowAttachments}
                                                                    />
                                                                )
                                                            ) : (
                                                                <div>
                                                                    <div className="text-center">
                                                                        <div className="text-secondary text-center p-4 mb-2">
                                                                            <p className="font-weight-bold">You’re all set! 🎉</p>
                                                                            Your accounting software is now connected — just hit Sync below.
                                                                        </div>
                                                                        <button onClick={handleSync} className="btn btn-outline-success mt-2 mb-2">
                                                                            Sync Now
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div> 
                                        {/*------------- accounting sw invoices / bills ------------------------*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}

            {/* Modals */}
            <ConnectModal
                show={accSwListModal}
                onHide={() => setAccSwListModal(false)}
                accountingSoftwares={accountingSoftwares}
                selectedAccSw={selectedAccSw}
                setSelectedAccSw={setSelectedAccSw}
                entityGuid={entityGuid}
                productId={product}
            />

            <AttachModal
                show={attachModalOpen}
                onHide={() => setAttachModalOpen(false)}
                attachItems={attachItems}
                attachName={attachName}
            />

            <AssignModal
                show={assignModalOpen}
                onHide={() => {
                    if (!syncSubmitting) setAssignModalOpen(false);
                }}
                selectedTransactions={selectedTransactions}
                clientDebtorList={clientDebtorList}
                selectedClientDebtors={selectedClientDebtors}
                revisedDueDate={revisedDueDate}
                revisedDueDateConstraints={revisedDueDateConstraints}   
                onChangeClientDebtor={(id, opt) => changeClientDebtor(id, opt)}
                onChangeDueDate={(id, date) => {
                    if (!date) return;
                    setRevisedDueDate((prev) => ({ ...prev, [id]: date }));   
                }}
                onSubmit={handleSyncSubmit}
                submitting={syncSubmitting}
                clientDebtorLoading={clientDebtorLoading}
                selProduct={product}
            />

            <Modal 
                show={resultModalOpen} 
                onHide={() => {
                    setResultModalOpen(false);
                    setAssignResult(null);
                    fetchAccSoftInvoices(); 
                }}
            >
                <Modal.Header closeButton>
                    <h5 className="modal-title">
                        {assignResult && !assignResult.assignedCount
                            ? 'Failed to upload the invoices'
                            : 'Some of the invoices failed to upload'}
                    </h5>
                </Modal.Header>
                <Modal.Body>
                    {assignResult && (
                    <>
                        {/* This modal only opens when at least one invoice failed, so the
                            summary is always red or amber - never a plain success line. */}
                        <div className={!assignResult.assignedCount ? 'alert alert-danger' : 'alert alert-warning'}>
                            <span className="font-weight-bold">
                                {!assignResult.assignedCount
                                    ? 'Failed to upload the invoices'
                                    : 'Some of the invoices failed to upload'}
                            </span>
                            <div>{assignResult.message}</div>
                        </div>
                        {assignResult.errors && assignResult.errors.length > 0 && (
                        <div>
                            <h6>Errors:</h6>
                            <table className="table table-bordered mt-3">
                                <thead>
                                    <tr>
                                    <th>Invoice Number</th>
                                    <th>Error</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {assignResult.errors.map((err, index) => (
                                    <tr key={index}>
                                        <td>{err.invoice_no || 'N/A'}</td>
                                        <td>{err.error}</td>
                                    </tr>
                                    ))}
                                </tbody>
                                </table>
                        </div>
                        )}
                    </>
                    )}
                    {isEarlyRisk && <EarlyRiskAlert />}
                </Modal.Body>
            </Modal>

            <Modal 
                show={syncResultModalOpen} 
                onHide={() => setSyncResultModalOpen(false)} 
                centered 
                size="lg"
            >
                <Modal.Header closeButton className={syncResult?.success ? "bg-success-subtle" : "bg-warning-subtle"}>
                    <Modal.Title>{syncResult?.success ? "Sync Completed" : "Sync Completed with Issues"}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p className="mb-3">{syncResult?.message}</p>

                    {/* Overview (no total count displayed) */}
                    {!!syncResult?.errors?.length && (
                    <div className="d-flex gap-3 flex-wrap mb-3">
                        <Stat label="Processed" value={syncResult?.processedCount ?? 0} />
                        <Stat label="Synced" value={syncResult?.syncedCount ?? 0} />
                        <Stat label="Failed" value={Math.max((syncResult?.processedCount ?? 0) - (syncResult?.syncedCount ?? 0), 0)} />
                    </div>
                    )}
                    {/* Details only if there are errors */}
                    {!!syncResult?.errors?.length && (
                        <>
                        <hr />
                        <h6 className="mb-2">Details</h6>
                        <div className="table-responsive">
                            <table className="table table-sm align-middle mb-0">
                            <thead>
                                <tr>
                                <th style={{ width: 160 }}>Invoice #</th>
                                <th>Message</th>
                                </tr>
                            </thead>
                            <tbody>
                                {syncResult.errors.map((e, i) => (
                                <tr key={i}>
                                    <td>{e?.inv_number || "-"}</td>
                                    <td>{e?.message || "-"}</td>
                                </tr>
                                ))}
                            </tbody>
                            </table>
                        </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>

            <Modal
                show={successModalOpen}
                onHide={closeSuccessModal}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Uploaded Successfully</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{successMessage}</p>
                    {isEarlyRisk && <EarlyRiskAlert />}
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-white"
                        onClick={closeSuccessModal}
                    >
                        Upload More
                    </button>
                    <Link
                        to={
                            product === constants.PRODUCTS.SUPPLYCHAIN
                            ? "/client/scf/purchase-invoices"
                            : "/client/tf/purchase-invoices"
                        }
                        className="btn btn-primary"
                        onClick={closeSuccessModal}
                    >
                        View Invoices
                    </Link>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showFacilityWarning}
                onHide={() => setShowFacilityWarning(false)}
                centered
                size="md"
                >
                <div className="bg-secondary text-white">
                    <Modal.Header closeButton>
                    <Modal.Title>Facility Suspended</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <p>{facilityWarningMessage}</p>
                    <p>Please contact your administrator or customer support.</p>
                    </Modal.Body>
                    <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => setShowFacilityWarning(false)}
                    >
                        Close
                    </button>
                    </Modal.Footer>
                </div>
            </Modal>
        </>

    );
}
